// extracted by mini-css-extract-plugin
export default {"blogSiderImg":"blog_blogSiderImg__1XEqq"};